import { render } from "./OrganismosDetalle.vue?vue&type=template&id=db97a852&ts=true"
import script from "./OrganismosDetalle.vue?vue&type=script&lang=ts"
export * from "./OrganismosDetalle.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__